import { zodResolver } from "@hookform/resolvers/zod";
import type { ComponentProps } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { enqueueSnackbar } from "../../../../../components/GlobalSnackbar/snackbarStore";
import { isSupabaseError } from "../../../../../constants/supabaseErrors";
import type AddQuoteApprovedActionModal from "./AddQuoteApprovedActionModal";
import useSubjectActionModal from "../useSubjectActionModal";
import { formSchema as formSchemaBase } from "../types";

const formSchema = formSchemaBase.extend({
  provider_id: z.string().nullable().optional(),
})

type FormInputs = z.input<typeof formSchema>;
type FormValues = z.infer<typeof formSchema>;

type Props = ComponentProps<typeof AddQuoteApprovedActionModal>;

export default function useAddQuoteApprovedActionModal(props: Props) {
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormInputs, unknown, FormValues>({
    mode: "onChange",
    defaultValues: {
      date: props.item?.date ? new Date(props.item.date) : new Date(),
      amount: props.item?.amount ?? undefined,
      comment: props.item?.comment || '',
      provider_id: props.item?.provider_id ?? null,
      documents: [],
    },
    resolver: zodResolver(formSchema),
  });

  const {
    isDocumentLoading,
    isLoading,
    handleCallApi,
  } = useSubjectActionModal(
    "quote_approved",
    props.item?.id ?? undefined,
    props.subjectId,
    form,
  );

  async function handleConfirm(data: FormValues) {
    setServerError(null);

    try {
      await handleCallApi(data)

      enqueueSnackbar((props.item && !props.isCopy) ? "Action mise à jour." : "Bon pour accord enregistré.", "success");
      props.onClose();
    } catch (error: unknown) {
      if (isSupabaseError(error)) {
        setServerError(error.message);
        return;
      }

      setServerError(
        "Une erreur est survenue",
      );
    }
  }

  return {
    form,
    handleConfirm,
    isLoading,
    serverError,
    isDocumentLoading,
  };
}
